<template>
  <div>
    <div class="has-text-right">
      <button class="button is-size-7" @click="setPanier([])">
        {{ $t('listeProduitReseauTempoDispo.panier.actions.clearSelection') }}
      </button>
    </div>
    <div v-for="(produit, index) in panier" :key="index">
      <div class="mgt-10px has-background-background">
        <div class="columns is-vcentered shadow is-marginless">
          <div class="panier-imgProduit column is-narrow is-paddingless is-flex">
            <img :src="produit.logo"
                 class="panier-imgProduit-logo" v-if="produit.logo"/>
            <div v-else>
              <div class="panier-imgProduit-reseauTempoLcMairie">
              </div>
            </div>
          </div>
          <div class="column mgl-10px is-paddingless">
            <b-field class="mgb-0">
              <p class="has-text-link is-size-6 ellipsis has-text-weight-bold textPanier">
                {{produit.reference }}
              </p>
            </b-field>
            <p class="has-text-default ellipsis textPanier">
              {{ produit.libelle }}
            </p>
          </div>
          <div class="column is-narrow">
            <a @click="deleteProduit(produit.id)">
              <b-icon
                icon="delete-forever"
                type="is-danger">
              </b-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { SET_PANIER, DELETE_LIGNE_IN_PANIER } from '@/store/modules/produitReseauTempo-mutation-type';

const ProduitReseauTempo = createNamespacedHelpers('produitReseauTempo');

export default {
  computed: {
    ...ProduitReseauTempo.mapGetters({
      panier: 'panier',
    }),
  },
  methods: {
    ...ProduitReseauTempo.mapMutations({
      deleteProduit: DELETE_LIGNE_IN_PANIER,
      setPanier: SET_PANIER,
    }),
  },
};
</script>
